import { useQuery } from "@tanstack/react-query";
import { getToken } from "../../helper/AxiosInstance";
import { getOnboardingAccess } from "./api";

export function useOnboardingAccess() {
  const token = getToken();

  return useQuery({
    queryKey: ["seller-onboarding-access", token],
    queryFn: async () => {
      const response = await getOnboardingAccess();
      return response.data;
    },
    enabled: Boolean(token),
    staleTime: 30_000,
    retry: false,
  });
}
